import { LayoutFeature } from "./layout/layout.mjs";
import { PanGesture } from "./gestures/pan/index.mjs";
import { AnimationFeature } from "./animation/animation.mjs";
import { ProjectionFeature } from "./layout/projection.mjs";
import { FocusGesture } from "./gestures/focus/index.mjs";
import { HoverGesture } from "./gestures/hover/index.mjs";
import { PressGesture } from "./gestures/press/index.mjs";
import { InViewGesture } from "./gestures/in-view/index.mjs";
import { DragGesture } from "./gestures/drag/index.mjs";
class FeatureManager {
  constructor(state) {
    this.features = [];
    this.features = [
      new HoverGesture(state),
      new PressGesture(state),
      new InViewGesture(state),
      new LayoutFeature(state),
      new ProjectionFeature(state),
      new PanGesture(state),
      new DragGesture(state),
      new FocusGesture(state),
      new AnimationFeature(state)
    ];
  }
  mount() {
    this.features.forEach((feature) => feature.mount());
  }
  beforeMount() {
    this.features.forEach((feature) => {
      var _a;
      return (_a = feature.beforeMount) == null ? void 0 : _a.call(feature);
    });
  }
  unmount() {
    this.features.forEach((feature) => feature.unmount());
  }
  update() {
    this.features.forEach((feature) => {
      var _a;
      return (_a = feature.update) == null ? void 0 : _a.call(feature);
    });
  }
  beforeUpdate() {
    this.features.forEach((feature) => feature.beforeUpdate());
  }
  beforeUnmount() {
    this.features.forEach((feature) => feature.beforeUnmount());
  }
}
export {
  FeatureManager
};
